import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Shield, Users, Award } from 'lucide-react';
import { Card } from '../ui/Card';
const features = [{
  icon: Heart,
  title: 'Family-Oriented',
  description: 'We believe families that train together grow together. Our environment is welcoming to parents and children alike.'
}, {
  icon: Shield,
  title: 'Female-Led Leadership',
  description: 'Experience a nurturing yet disciplined approach to martial arts, led by professional female instructors who lead by example.'
}, {
  icon: Users,
  title: 'Community Focused',
  description: "We are not a chain. We are a locally owned school deeply invested in the Brighton community and our students' success."
}, {
  icon: Award,
  title: 'Confidence Building',
  description: 'Our curriculum is designed to build self-esteem and resilience, helping students succeed in all areas of life.'
}];
export function WhyLimitlessSection() {
  return <section className="py-20 bg-white" data-id="element-141">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-142">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-143">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-144">
            Why Choose Limitless Taekwondo?
          </h2>
          <p className="text-lg text-gray-600" data-id="element-145">
            We're more than just a martial arts school. We're a supportive
            community dedicated to your family's growth and well-being.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-146">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} data-id="element-147">
              <Card className="h-full p-6 text-center hover:shadow-md transition-shadow" data-id="element-148">
                <div className="w-12 h-12 mx-auto bg-blue-50 rounded-full flex items-center justify-center mb-6" data-id="element-149">
                  <feature.icon className="w-6 h-6 text-primary" data-id="element-150" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-151">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-152">
                  {feature.description}
                </p>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}